export default function CompositePage() {
  return (
    <ul>
      <li>Composite: </li>
    </ul>
  );
}
